// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import base64 from 'base-64';
import {get} from 'lodash';

// Relative Imports
import createAccountActions from '../../actions/accountCreation';
import appActions from '../../actions/actions';
import helpActions from '../../actions/help';
import CreateAccount from './CreateAccount';
import AlertBox from '../Alert/Alert';
import {checkPasswordHasNumber, checkPasswordHasLetter, getDefaultCountryCode} from '../utils/createAccountUtil';
import {DEEP_LINK_PARAM_TYPE} from '../../utils/localStorageDataHandler';

function mapStateToProps(state) {
    return {
        translations: state.app.translations,
        environment: state.system.environment,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        ulxParams: get(state, 'app.ulxParams', {}),
        pmscParams: get(state, 'app.pmscParams', {}),
        brandSwitchParams: get(state, 'app.brandSwitchParams', {}),
        recaptchaResp: get(state, 'app.caRecaptchaResp', ''),
        firstName: get(state, 'account.firstName', ''),
        lastName: get(state, 'account.lastName', ''),
        dialingCountryCode: get(state, 'account.dialingCountryCode', 'us'),
        countryDialingNumber: get(state, 'account.countryDialingNumber', '1'),
        phoneNumber: get(state, 'account.phoneNumber', ''),
        companyName: get(state, 'account.companyName', ''),
        companyNameFromState: get(state, 'companyLocation.companyName', ''),
        email: get(state, 'account.email', ''),
        password: get(state, 'account.password', ''),

        firstNameError: get(state, 'account.firstNameError', ''),
        lastNameError: get(state, 'account.lastNameError', ''),
        phoneNumberError: get(state, 'account.phoneNumberError', ''),
        companyNameError: get(state, 'account.companyNameError', ''),
        emailError: get(state, 'account.emailError', ''),
        passwordError: get(state, 'account.passwordError', ''),

        enableCreateAccountButton: get(state, 'account.enableCreateAccountButton', false),
        serviceError: get(state, 'account.serviceError', ''),
        accountExistsError: get(state, 'account.accountExistsError', ''),
        passwordFieldType: get(state, 'account.passwordFieldType', 'password'),
        passwordNotify: get(state, 'account.passwordNotify', 'password'),
        publicUuid: get(state, 'app.publicUuid', '-1'),
        companyCountryCode: get(state, 'companyLocation.companyCountryCode', ''),
        propertyCount: get(state, 'propertyCount.numberOfProperty', ''),
        registrationNumber: get(state, 'companyLocation.registrationNumber', ''),
        currency: get(state, 'currency.currency', ''),
        redirectFlag: get(state, 'masterBrand.redirectFlag', true)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createAccountActions: bindActionCreators(createAccountActions, dispatch),
        appActions: bindActionCreators(appActions, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class CreateAccountContainer extends React.Component {
    constructor(props) {
        super(props);
        this.setFirstName = this.setFirstName.bind(this);
        this.setLastName = this.setLastName.bind(this);
        this.setDialingCountryCode = this.setDialingCountryCode.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.setCompanyName = this.setCompanyName.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setPassword = this.setPassword.bind(this);

        this.onFirstNameBlur = this.onFirstNameBlur.bind(this);
        this.onLastNameBlur = this.onLastNameBlur.bind(this);
        this.onCompanyNameBlur = this.onCompanyNameBlur.bind(this);
        this.onEmailBlur = this.onEmailBlur.bind(this);
        this.onPasswordBlur = this.onPasswordBlur.bind(this);
        this.onPhoneBlur = this.onPhoneBlur.bind(this);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleFormAlertDismiss = this.handleFormAlertDismiss.bind(this);
        this.togglePasswordType = this.togglePasswordType.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.triggerEdapEventOnPhoneFocus = this.triggerEdapEventOnPhoneFocus.bind(this);
        this.onPasswordKeyUp = this.onPasswordKeyUp.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }

    componentWillMount() {
        const {companyNameFromState, locale, redirectFlag, brandSwitchParams} = this.props;
        this.props.createAccountActions.setCompanyName(companyNameFromState || '');
        this.props.createAccountActions.setDialingCountryCode(getDefaultCountryCode(locale));
        this.props.appActions.enableLoadOverLay(false);
        if (redirectFlag) {
            this.props.createAccountActions.prePopulateBasicInfo(brandSwitchParams);
        }
    }

    componentDidMount() {
        window.recaptchaOptions = {
            lang: this.props.preferredLocale
        };
    }

    componentWillReceiveProps(nextProps) {
        this.onRecaptchaRespChange(nextProps);
        this.setDefaultCountryDialingNumber(nextProps);
        this.onServiceErrorChange(nextProps);
    }

    setDefaultCountryDialingNumber(nextProps) {
        if (!this.props.enableCreateAccountButton) {
            if (this.props.phoneNumber === "" || nextProps.enableCreateAccountButton)  {
                this.props.createAccountActions.setCountryDialingNumber(this.inputTel?.state?.phoneCode);
            }
        }
    }


    onRecaptchaRespChange(nextProps) {
        if (!this.props.recaptchaResp && nextProps.recaptchaResp) {
            const {systemId, systemName} = this.props.ulxParams;

            if (systemId && systemName) {
                this.props.appActions.saveDeepLinkParams(DEEP_LINK_PARAM_TYPE.ulxParams, {systemId, systemName});
            }

            this.submitCreateAccountForm(nextProps.recaptchaResp);
        }
    }

    onServiceErrorChange(nextProps) {
        if (!this.props.serviceError && nextProps.serviceError ||
            !this.props.accountExistsError && nextProps.accountExistsError) {
            this.recaptchaRef.reset();
        }
    }

    onCaptchaChange(response) {
        this.props.appActions.setCaptchaResponse('ca', response);
    }

    triggerEdapEventOnFocus(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Focus on input field:${event.target.name}`,
            highfrequency: 'true'
        }, {});
    }

    triggerEdapEventOnPhoneFocus() {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Phone',
            eventaction: 'Focus on Phone field',
            highfrequency: 'true'
        }, {});
    }

    onPasswordKeyUp(event) {
        const pwdVal = event.target.value;
        let hasNumber;
        let hasLetter;
        let isStrong = false;
        let display = false;

        if (pwdVal.length >= 2) {
            display = true;
            hasNumber = checkPasswordHasNumber(pwdVal);
            hasLetter = checkPasswordHasLetter(pwdVal);

            if (pwdVal.length >= 7) {
                isStrong = true;
            }
        }

        const passwordNotify = {
            display,
            hasNumber,
            hasLetter,
            isStrong
        };
        this.props.createAccountActions.setPasswordNotify(passwordNotify);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Create Account Page');
    }

    setFirstName(event) {
        event.preventDefault();
        this.whiteSpaceValidation(event);
        this.setFieldsError('firstName');
        this.props.createAccountActions.setFirstName(event.target.value);
        this.props.createAccountActions.toggleContinueButton();
    }

    setLastName(event) {
        event.preventDefault();
        this.whiteSpaceValidation(event);
        this.setFieldsError('lastName');
        this.props.createAccountActions.setLastName(event.target.value);
        this.props.createAccountActions.toggleContinueButton();
    }

    setDialingCountryCode(event, countryData) {
        this.props.createAccountActions.setDialingCountryCode(countryData.cc);
        this.props.createAccountActions.setCountryDialingNumber(countryData.phoneCode);
        this.props.createAccountActions.toggleContinueButton();
    }

    setPhoneNumber(event, phoneObject) {
        this.props.createAccountActions.setPhoneNumber(phoneObject.raw);
        this.props.createAccountActions.toggleContinueButton();
        if (phoneObject.raw) {
            this.setFieldsError('phoneNumber');
        }
    }

    setCompanyName(event) {
        event.preventDefault();
        this.whiteSpaceValidation(event);
        this.setFieldsError('companyName');
        this.props.createAccountActions.setCompanyName(event.target.value);
        this.props.createAccountActions.toggleContinueButton();
    }


    setEmail(event) {
        event.preventDefault();
        this.setFieldsError('email');
        this.props.createAccountActions.setEmail(event.target.value);
        this.props.createAccountActions.toggleContinueButton();
    }

    setPassword(event) {
        event.preventDefault();
        this.setFieldsError('password');
        this.props.createAccountActions.setPassword(event.target.value);
        this.props.createAccountActions.toggleContinueButton();
    }

    onFirstNameBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validateFirstName(this.props.firstName);
    }

    onLastNameBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validateLastName(this.props.lastName);
    }

    onCompanyNameBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validateCompanyName(this.props.companyName);
    }

    onEmailBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validateEmail(this.props.email);
    }

    onPasswordBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validatePassword(this.props.password);
    }

    onPhoneBlur(event) {
        event.preventDefault();
        this.props.createAccountActions.validatePhone(this.props.phoneNumber);
    }

    whiteSpaceValidation(event) {
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.createAccountActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    setFieldsError(errorField) {
        const fields = [
            'firstName',
            'lastName',
            'phoneNumber',
            'companyName',
            'email',
            'password'
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.createAccountActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'firstName' && !this.props.firstName.trim())
                || (fieldVal === 'lastName' && !this.props.lastName.trim())
                || (fieldVal === 'phoneNumber' && !this.props.phoneNumber)
                || (fieldVal === 'companyName' && !this.props.companyName.trim())
                || (fieldVal === 'email' && !this.props.email)
                || (fieldVal === 'password' && !this.props.password)) {
                this.props.createAccountActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.recaptchaRef.execute();
    }

    submitCreateAccountForm = (recaptchaResp) => {
        const accountDetails = {
            email: base64.encode(this.props.email),
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            password: base64.encode(this.props.password),
            companyName: this.props.companyName,
            phoneNumber: this.props.phoneNumber,
            countryCode: this.props.countryDialingNumber,
            companyLocation: this.props.companyCountryCode || '',
            propertyCount: this.props.propertyCount || '',
            companyRegistration: this.props.registrationNumber || '',
            currency: this.props.currency || this.props.brandSwitchParams.currency,
            recaptchaResp
        };

        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Create Account'
        }, {});

        this.props.createAccountActions.createAccount(accountDetails);
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.setCaptchaResponse('ca', '');
        this.props.createAccountActions.setAccountExistsError('');
        this.props.createAccountActions.alertError('');
    }

    handleAlertDismiss() {
        this.props.createAccountActions.alertError('');
    }

    handleFormAlertDismiss() {
        this.props.createAccountActions.setAccountExistsError('');
    }

    togglePasswordType() {
        if (this.props.passwordFieldType === 'password') {
            this.props.createAccountActions.setPasswordType('text');
        } else {
            this.props.createAccountActions.setPasswordType('password');
        }
    }

    getInputTel = (ref) => {
        this.inputTel = ref;
    }

    setRecaptchaRef = (ref) => {
        this.recaptchaRef = ref;
    }

    onHelpClick = () => {
        this.props.helpActions.toggleHelpModal(true, 'helpModal');
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'click here for help'
        }, {});
    }

    render() {
        const toBeRender = (<div>
            {this.props.serviceError ?
                <AlertBox
                    messageKey={this.props.serviceError}
                    translations={this.props.translations}
                    handleAlertDismiss={this.handleAlertDismiss}
                /> : null}
            <CreateAccount
                translations = {this.props.translations}
                environment = {this.props.environment}

                firstNameError = {this.props.firstNameError}
                firstNameVal = {this.props.firstName}
                handleFirstNameChange = {this.setFirstName}
                handleFirstNameBlur = {this.onFirstNameBlur}

                lastNameError = {this.props.lastNameError}
                lastNameVal = {this.props.lastName}
                handleLastNameChange = {this.setLastName}
                handleLastNameBlur = {this.onLastNameBlur}

                countryCodeVal = {this.props.dialingCountryCode}
                phoneNumberVal = {this.props.phoneNumber}
                phoneNumberError = {this.props.phoneNumberError}
                handlePhoneNumberChange = {this.setPhoneNumber}
                handleCountryCodeChange = {this.setDialingCountryCode}

                companyNameVal = {this.props.companyName}
                companyNameError = {this.props.companyNameError}
                handleCompanyNameChange = {this.setCompanyName}
                handleCompanyNameBlur = {this.onCompanyNameBlur}

                emailError = {this.props.emailError}
                emailVal = {this.props.email}
                handleEmailChange = {this.setEmail}
                handleEmailBlur = {this.onEmailBlur}
                handlePhoneBlur = {this.onPhoneBlur}

                passwordError = {this.props.passwordError}
                passwordVal = {this.props.password}
                handlePasswordChange = {this.setPassword}
                handlePasswordBlur= {this.onPasswordBlur}
                passwordFieldType = {this.props.passwordFieldType}

                handleFormSubmit = {this.handleFormSubmit}
                enableButton = {this.props.enableCreateAccountButton}
                togglePasswordType = {this.togglePasswordType}
                onPasswordKeyUp = {this.onPasswordKeyUp}
                passwordNotify = {this.props.passwordNotify}

                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                triggerEdapEventOnFocus = {this.triggerEdapEventOnFocus}
                triggerEdapEventOnPhoneFocus={this.triggerEdapEventOnPhoneFocus}

                accountExistsError={this.props.accountExistsError}
                handleFormAlertDismiss={this.handleFormAlertDismiss}
                onCaptchaChange={this.onCaptchaChange}
                serviceError={this.props.serviceError}
                getInputTel={this.getInputTel}
                setRecaptchaRef={this.setRecaptchaRef}
                onHelpClick={this.onHelpClick}
            />
        </div>);
        return (toBeRender);
    }
}

CreateAccountContainer.propTypes = {

    firstName: PropTypes.string,
    firstNameError: PropTypes.string,

    lastName: PropTypes.string,
    lastNameError: PropTypes.string,

    dialingCountryCode: PropTypes.string,
    countryDialingNumber: PropTypes.string,
    phoneNumber: PropTypes.string,
    phoneNumberError: PropTypes.string,

    companyName: PropTypes.string,
    companyNameError: PropTypes.string,

    email: PropTypes.string,
    emailError: PropTypes.string,

    password: PropTypes.string,
    passwordError: PropTypes.string,

    enableCreateAccountButton: PropTypes.bool,
    serviceError: PropTypes.string,

    passwordFieldType: PropTypes.string,
    passwordNotify: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,

    recaptchaResp: PropTypes.string,
    companyCountryCode: PropTypes.string,
    propertyCount: PropTypes.string,
    currency: PropTypes.string
};

CreateAccountContainer.defaultProps = {

    firstName: '',
    firstNameError: '',

    lastName: '',
    lastNameError: '',

    dialingCountryCode: '',
    countryDialingNumber: '',
    phoneNumber: '',
    phoneNumberError: '',

    companyName: '',
    companyNameError: '',

    email: '',
    emailError: '',

    password: '',
    passwordError: '',

    enableCreateAccountButton: false,
    serviceError: '',

    passwordFieldType: '',
    publicUuid: '-1',
    recaptchaResp: '',
    companyCountryCode: '',
    propertyCount: '',
    currency: ''
};

export default CreateAccountContainer;
